//#region src/client/hooks/use-consent-actions.ts
const useConsentActions = (config) => {
	const { onUpdateConsents, onError } = config;
	const createConsentInput = (consent, status) => ({
		consentHash: consent.hash,
		consentVersionId: consent.currentVersionId,
		status,
		consentType: consent.consentType
	});
	const executeConsentAction = async (consent, updatedStatus) => {
		try {
			await onUpdateConsents([createConsentInput(consent, updatedStatus)]);
		} catch (error) {
			console.error("Error updating consent:", error);
			onError?.();
		}
	};
	const acceptConsent = (consent) => executeConsentAction(consent, "ACTIVE");
	const revokeConsent = (consent) => executeConsentAction(consent, "REVOKED");
	const batchUpdateConsents = async (consents) => {
		try {
			await onUpdateConsents(consents.map(({ consent, status }) => createConsentInput(consent, status)));
		} catch (error) {
			console.error("Error updating consents:", error);
			onError?.();
		}
	};
	return {
		acceptConsent,
		revokeConsent,
		batchUpdateConsents
	};
};

//#endregion
export { useConsentActions };